import { Link } from '@tanstack/react-router';
import { Compass, ShieldOff } from 'lucide-react';
import { T } from '@/design/tokens';

/** 404 do admin: fala a língua do operador e oferece o caminho de volta. */
export function NotFoundPage() {
  return (
    <div style={{ padding: 48, display: 'flex', justifyContent: 'center' }}>
      <div className="state" style={{ maxWidth: 460 }}>
        <Compass size={22} color={T.inkFaint} aria-hidden />
        <div className="state__title">Esta tela não existe</div>
        <div className="state__text">
          O endereço pode ter mudado, ou o módulo ainda não foi construído.
        </div>
        <div className="state__action">
          <Link to="/" className="btn btn--primary">
            Ir para a Visão Geral
          </Link>
        </div>
      </div>
    </div>
  );
}

/** 403 no cliente. O servidor recusa de novo — isto é só para não frustrar. */
export function ForbiddenPage() {
  return (
    <div style={{ padding: 48, display: 'flex', justifyContent: 'center' }}>
      <div className="state" style={{ maxWidth: 460 }}>
        <ShieldOff size={22} color={T.amber} aria-hidden />
        <div className="state__title">Você não tem acesso a esta tela</div>
        <div className="state__text">
          Seu perfil não inclui esta permissão. Fale com o Diretor se precisar dela.
        </div>
        <div className="state__action">
          <Link to="/" className="btn btn--outline">
            Voltar para a Visão Geral
          </Link>
        </div>
      </div>
    </div>
  );
}
